// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DataTable_wrapper__Qo-5t","tableContainer":"DataTable_tableContainer__3yThS","table":"DataTable_table__qHnzZ","paginationWrapper":"DataTable_paginationWrapper__qovRl"};